import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyMagicLinkRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyMagicLinkResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyMagicLink = (request: VerifyMagicLinkRequest, options?: CashRequestOptions) =>
  post<VerifyMagicLinkRequest, VerifyMagicLinkResponse>('/2.0/cash/verify-magic-link', request, {
    ...options,
    rejectOnError: true,
  })
